import { render, staticRenderFns } from "./RoleUpload.vue?vue&type=template&id=0e73b8e5&scoped=true"
import script from "./RoleUpload.vue?vue&type=script&lang=js"
export * from "./RoleUpload.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e73b8e5",
  null
  
)

export default component.exports